module.exports = __webpack_public_path__ + "img/alert.38694a05.png";